import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms"; // Import ReactiveFormsModule
import { MatButtonModule } from "@angular/material/button"; // Import MatButtonModule
import { MatDialogModule } from "@angular/material/dialog"; // Import MatDialogModule
import { MatIconModule } from "@angular/material/icon"; // Import MatIconModule

import { EditbidComponent } from "./editbid/editbid.component"; // Import EditbidComponent
import { TokenDetailsComponent } from "./shared/token-details/token-details.component"; // Import TokenDetailsComponent
import { StrikePriceComponent } from "./strike-price/strike-price.component"; // Import StrikePriceComponent
import { UserRoutingModule } from "./user-routing.module";
import { WebPaymentModelComponent } from "./web-payment-model/web-payment-model.component";

@NgModule({
  declarations: [
    StrikePriceComponent, // Declare StrikePriceComponent
    TokenDetailsComponent, // Declare TokenDetailsComponent
    EditbidComponent, // Declare EditbidComponent
    WebPaymentModelComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    ReactiveFormsModule, // Add ReactiveFormsModule to imports
    MatDialogModule, // Add MatDialogModule to imports
    MatIconModule, // Add MatIconModule to imports
    MatButtonModule, // Add MatButtonModule to imports
  ],
})
export class UserModule {}
